module.exports = __webpack_public_path__ + "assets/img/mecha-btn-dfdf6825.png";